import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { deleteClaimCampaign } from '~/services/ClaimCampaignService';

import { claimCampaignQueryKeys } from './claimCampaignQueryKeys';

/**
 * Deletes a claim campaign and invalidates the campaign list cache.
 */
export function useDeleteClaimCampaign() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (campaignId: string) => {
      return await deleteClaimCampaign(campaignId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: claimCampaignQueryKeys.all });
      enqueueSnackbar('Claim campaign deleted successfully', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error deleting claim campaign: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
